<script lang="tsx">
import { ElPagination } from "element-plus";
import loadDataMixFunc, { loadDataProps } from "../../commonMix/loadData";
import {
  defineComponent, h, watch } from "vue";
import type { ExtractPropTypes, CSSProperties, PropType, VNode, ComponentPublicInstance, StyleValue } from "vue";
import type { LoadDataStateType, LoadDataOperateType } from "../../commonMix/loadData/types";
const DataListProps = {
  ...loadDataProps,
  loading: {
    type: Boolean,
    default: undefined,
  },
  showLoadingIcon: {
    type: Boolean,
    default: true,
  },
  listStyle: {
    type: Object as PropType<CSSProperties>,
    default: () => ({}),
  },
};
type DataListPropsType = ExtractPropTypes<typeof DataListProps>;

export default defineComponent({
  name: "DataList",
  components: {
    ElPagination,
  },
  emits: ["update:loading", "loading-change"],

  props: DataListProps,
  setup(props: DataListPropsType, ctx: any): LoadDataOperateType {
    let allFunc: LoadDataOperateType = loadDataMixFunc(props, ctx, {
      afterSuccessFunc: (_d: any) => {
        _d;
      },
      afterErrorFunc: (_d: any) => {
        _d;
      },
    });
    watch(
      () => allFunc.loadDataState.loading,
      (loading: boolean) => {
        ctx.emit("update:loading", loading);
        ctx.emit("loading-change", loading);
      },
      { immediate: true }
    );
    return allFunc;
  },
  render(
    _ctx: ComponentPublicInstance<DataListPropsType, LoadDataOperateType>
  ): VNode {
    const {
      loadDataState,

      listStyle,
      showLoadingIcon,
      pageProps,
      handleCurrentChange,
      handleSizeChange,
      pagination,
    } = _ctx;
    const pageOn = {
      "onUpdate:current-page": handleCurrentChange,
      "onUpdate:page-size": handleSizeChange,
    };
    const setPageProps = {
      total: loadDataState.total,
      layout: "total,sizes,prev,pager,next,jumper",
      pageSizes: [10, 30, 50],
      background: true,
      ...pageProps,
      "current-page": loadDataState.currentPage,
      pageSize: pagination ? loadDataState.pageSize : 1000000000,
    };

    return (
      <div class="comp-datalist" style={_ctx.$attrs.style as StyleValue}>
        <div
          class="comp-datalist-box"
          style={listStyle}
          v-loading={showLoadingIcon && loadDataState.loading}
        >
          {loadDataState.listData.map((item: any, idx: number) =>
            idx >= loadDataState.pageSize && pagination
              ? null
              : _ctx.$slots.default
              ? _ctx.$slots.default(Object.assign({}, item, { idx }))
              : null
          )}
          {loadDataState.listData.length==0 && _ctx.$slots.empty? _ctx.$slots.empty():null}
        </div>
        {!!loadDataState.total && pagination
          ? h(ElPagination, { ...pageOn, ...setPageProps })
          : null}
      </div>
    );
  },
});
</script>
